const type = 'SET_PHOTO'
const set = photo => ({ type, photo })
const reducer = (state = null, action) => action.type === type ? action.photo : state

export default { set: set, reducer: reducer }
